<div id="tabConsultar">
  <div class="tituloInt tituloPago">{{ 'DINERO_EN_CAJA' | translate }}</div>
  <fieldset>
    <div class="gestionInputWrap" [formGroup]="arqueoForm">
      <!-- <div class="form-group readonly">
  <div class="tit-form-group">
    <label for="cambioInicialInput">Cambio inicial</label>
  </div>
  <input type="text" class="form-control" id="cambioInicialInput" value="{{cambio.cambioInicial | number : '1.2-2'}}" readonly>
</div> -->
      <!-- <div class="form-group readonly">
  <div class="tit-form-group">
    <label for="cambioRetiradoInput">Cambio retirado</label>
  </div>
  <input type="text" class="form-control" id="cambioRetiradoInput" value="{{cambio.cambioRetirado | number : '1.2-2'}}" readonly>
</div>
<div class="form-group readonly">
  <div class="tit-form-group">
    <label for="cambioIntroducidoInput">Cambio introducido</label>
  </div>
  <input type="text" class="form-control" id="cambioIntroducidoInput" value="{{cambio.cambioIntroducido | number : '1.2-2'}}" readonly>
</div> -->
      <div class="form-group readonly" *ngIf="tienePermiso('TurnoArqueoCiego')">
        <div class="tit-form-group">
          <label for="ventasEfectivoInput">{{ 'VENTAS_EFECTIVO' | translate }}</label>
        </div>
        <input type="text" class="form-control" id="ventasEfectivoInput"
               value="{{cambio.ventasEfectivo | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}" readonly>
      </div>
      <div class="form-group">
        <div class="tit-form-group">
          <label for="cierreEfectivo">{{ 'EFECTIVO' | translate }}</label>
        </div>
        <input type="text" #cambioEfectivo category="DIVISA" formControlName="efectivo" #efectivo
               class="form-control" [ngClass]="{'active-form' : isSelected(cambioEfectivo)}" id="arqueoEfectivo"
               [placeholder]="placeholderValue" (focus)="focusValue($event)">
      </div>
      <div class="form-group textarea">
        <div class="tit-form-group">
          <label for="comentarios">{{ 'COMENTARIOS' | translate }}</label>
        </div>
        <textarea formControlName="comentario" #comentario (focus)="focusValue($event)" category="TEXTAREA"
                  class="form-control" rows="2" cols="40" id="comentarios"
                  [ngClass]="{'active-form' : isSelected(comentario)}"></textarea>
      </div>
      <!-- <div class="form-group readonly">
  <div class="tit-form-group">
    <label for="cambioResultanteInput">Cambio resultante</label>
  </div>
  <input type="text" class="form-control" id="cambioResultanteInput" value="{{cambio.cambioResultante | number : '1.2-2':locale }}" readonly>
</div> -->
    </div>
    <div class="btn-continuar-wrap">
      <a class="SiguienteButton ArqueoParcial" title="{{ 'ARQUEO_PARCIAL' | translate }}" (click)="arqueoParcial()">{{ 'ARQUEO_PARCIAL' | translate }}</a>
    </div>
  </fieldset>
</div>

<ng-container>
  <body [hidden]='true' *ngIf="datosInforme">
  <table id="my-table1">
    <thead>
    <tr>
      <th>{{ 'DATOS_IDENTIFICATIVOS' | translate }}</th>
    </tr>
    </thead>
  </table>
  <table id="my-table2">
    <tbody>
    <tr>
      <th>{{ 'NOMBRE_TPV' | translate }}:</th>
      <td>{{ datosInforme.TPVNombre }}</td>
    </tr>
    <tr>
      <th>{{ 'FECHA' | translate }}:</th>
      <td>{{ calculaFecha(datosInforme.FechaArqueo) }}</td>
    </tr>
    <tr>
      <th>{{ 'HORA_INICIO_CAJA' | translate }}:</th>
      <td> <!--{{calculaHora(datosInforme.FechaInicio)}}--></td>
    </tr>
    <tr>
      <th>{{ 'HORA_CIERRE_CAJA' | translate }}:</th>
      <td><!--{{calculaHora(datosInforme.FechaCierre)}}--></td>
    </tr>
    </tbody>
  </table>
  <table id="my-table3">

    <thead>
    <tr>
      <th>{{ 'NOMBRE_USUARIO' | translate }}</th>
      <th>{{ 'HORA_INICIO_SESION' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <ng-container>
      <tr *ngFor="let usuario of usuarios">
        <td>{{ usuario.UsuarioNombre }}</td>
        <td>{{ calculaHora(usuario.FechaHoraInicio) }}</td>
      </tr>
    </ng-container>
    <ng-container *ngIf="usuarios.length < 3">
      <tr>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td></td>
      </tr>
    </ng-container>
    </tbody>
  </table>
  <table id="my-table4">
    <thead>
    <tr>
      <th>{{ 'DATOS_PRODUCTOS' | translate }}</th>
    </tr>
    </thead>
  </table>
  <table id="my-table5">
    <thead>
    <tr>
      <th>{{ 'ENTRADAS' | translate }}</th>
    </tr>
    </thead>
  </table>
  <table id="my-table6">
    <tbody>
    <tr>
      <td>{{ 'CONFIGURACION_PRODUCTO' | translate }}</td>
      <td>{{ 'VENTA' | translate }}</td>
      <td>{{ 'RESERVA' | translate }}</td>
      <td>{{ 'DEVOLUCION' | translate }}</td>
      <td>{{ 'TOTAL' | translate }}</td>
      <td>{{ 'PRECIO_UNIDAD' | translate }}</td>
      <td>{{ 'PRECIO_TOTAL' | translate }}</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table7">
    <tbody>
    <ng-container *ngFor="let produto of productosVenta">
      <tr>
        <td>{{ produto.ProductoNombre }}</td>
        <td>{{ produto.ProductoCantidad }}</td>
        <td>0</td>
        <td>0</td>
        <td>0</td>
        <td>{{ calculaPrecioUnitario(produto.ProductoImporteTotal, produto.ProductoCantidad) }}</td>
        <td>{{ produto.ProductoImporteTotal | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
      </tr>
    </ng-container>
    </tbody>
  </table>
  <table id="my-table8">
    <tbody>
    <tr>
      <td>{{ 'TOTAL_ENTRADAS' | translate }}</td>
      <td>{{ calculaTotalNumVentas() }}</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>{{ calculaTotalImporteVentas() }}</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table9">
    <thead>
    <tr>
      <th>{{ 'ACTIVIDADES' | translate }}</th>
    </tr>
    </thead>
  </table>
  <table id="my-table10">
    <tbody>
    <tr>
      <td>{{ 'CONFIGURACION_PRODUCTO' | translate }}</td>
      <td>{{ 'VENTA' | translate }}</td>
      <td>{{ 'RESERVA' | translate }}</td>
      <td>{{ 'DEVOLUCION' | translate }}</td>
      <td>{{ 'TOTAL' | translate }}</td>
      <td>{{ 'PRECIO_UNIDAD' | translate }}</td>
      <td>{{ 'PRECIO_TOTAL' | translate }}</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table11">
    <tbody>
    <tr>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table12">
    <tbody>
    <tr>
      <td>{{ 'TOTAL_ACTIVIDADES' | translate }}</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table13">
    <thead>
    <tr>
      <th>{{ 'SERVICIOS' | translate }}</th>
    </tr>
    </thead>
  </table>
  <table id="my-table14">
    <tbody>
    <tr>
      <td>{{ 'CONFIGURACION_PRODUCTO' | translate }}</td>
      <td>{{ 'VENTA' | translate }}</td>
      <td>{{ 'RESERVA' | translate }}</td>
      <td>{{ 'DEVOLUCION' | translate }}</td>
      <td>{{ 'TOTAL' | translate }}</td>
      <td>{{ 'PRECIO_UNIDAD' | translate }}</td>
      <td>{{ 'PRECIO_TOTAL' | translate }}</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table15">
    <tbody>
    <tr>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table16">
    <tbody>
    <tr>
      <td>{{ 'TOTAL_SERVICIOS' | translate }}</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table17">
    <thead>
    <tr>
      <th>{{ 'OTROS' | translate }}</th>
    </tr>
    </thead>
  </table>
  <table id="my-table18">
    <tbody>
    <tr>
      <td>{{ 'CONFIGURACION_PRODUCTO' | translate }}</td>
      <td>{{ 'VENTA' | translate }}</td>
      <td>{{ 'RESERVA' | translate }}</td>
      <td>{{ 'DEVOLUCION' | translate }}</td>
      <td>{{ 'TOTAL' | translate }}</td>
      <td>{{ 'PRECIO_UNIDAD' | translate }}</td>
      <td>{{ 'PRECIO_TOTAL' | translate }}</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table19">
    <tbody>
    <tr>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table20">
    <tbody>
    <tr>
      <td>{{ 'TOTAL_OTROS' | translate }}</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table21">
    <tbody>
    <tr>
      <td>{{ 'TOTAL' | translate }}</td>
      <td>{{ calculaTotalNumVentas() }}</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>0</td>
      <td>{{ calculaTotalImporteVentas() }}</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table22">
    <thead>
    <tr>
      <th>{{ 'DATOS_CIERRE_CAJA' | translate }}</th>
    </tr>
    </thead>
  </table>
  <table id="my-table23">
    <tbody>
    <tr>
      <td>{{ 'TOTAL_VENTAS' | translate }}</td>
      <td>{{ datosInforme.ImporteTotal | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
    </tr>
    <tr>
      <td>{{ 'VALIDACIONES_VENTA_ONLINE' | translate }}</td>
      <td>0 €</td>
    </tr>
    <tr>
      <td>{{ 'VENTAS_TRANSFERENCIA' | translate }}</td>
      <td>{{ datosInforme.ImporteTR | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
    </tr>
    <tr>
      <td>{{ 'VENTAS_TARJETA_BANCARIA' | translate }}</td>
      <td>{{ datosInforme.ImporteCC | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
    </tr>
    <tr>
      <td>{{ 'VENTAS_EFECTIVO' | translate }}</td>
      <td>{{ datosInforme.ImporteCA | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
    </tr>
    <tr>
      <td>{{ 'VENTAS_EFECTIVO_ARQUEO_MANUAL' | translate }}</td>
      <td>{{ datosInforme.ImporteSupervisor | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
    </tr>
    <tr>
      <td>{{ 'DIFERENCIA_CAJA_ARQUEO_MANUAL' | translate }}</td>
      <td>{{ datosInforme.Diferencia | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table24">
    <thead>
    <tr>
      <th>{{ 'COMENTARIOS' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{ comentarios }}</td>
    </tr>
    </tbody>
  </table>
  <table id="my-table25">
    <tbody>
    <tr>
      <th>{{ 'FIRMA_USUARIO_CIERRE_CAJA' | translate }}</th>
      <th>{{ 'FIRMA_COORDINADOR_SERVICIO' | translate }}</th>
    </tr>
    </tbody>
  </table>
  </body>
</ng-container>
